export default "<app-container>\n    <app-register-form></app-register-form>\n</app-container>\n";